import {Model} from "@/store/models/model"
import axios from "@/store/vue-axios"

export class VserverGraph extends Model {

  static entity = 'vserver_graph'
  static primaryKey = 'tid'
  static apiEntity = 'graph'

  static fields() {
    return {
      tid:this.attr(null),
      vid:this.attr(null),
      cf:this.attr(null),
      timeframe:this.attr(null),
      maxmem: this.attr([]),
      disk: this.attr([]),
      diskread: this.attr([]),
      maxdisk: this.attr([]),
      diskwrite: this.attr([]),
      mem: this.attr([]),
      maxcpu: this.attr([]),
      netout: this.attr([]),
      netin: this.attr([]),
      cpu: this.attr([]),
      time: this.attr([])
    }
  }
  static timelines(){
    return {
        live:'Live',
        hour:'Stunde',
        day:'Tag',
        week:'Woche',
        month:'Monat',
        year:'Jahr'
    }
  }
  static modelNames(vid){
    const ll = [
      "_hour_AVERAGE",
      "_hour_MAX",
      "_month_MAX",
      "_live_MAX",
      "_week_MAX",
      "_year_MAX",
      "_day_MAX",
      "_month_AVERAGE",
      "_week_AVERAGE",
      "_year_AVERAGE",
      "_live_AVERAGE",
      "_day_AVERAGE"
    ]
    return ll.map(el=>vid+el)
  }
  static async getGraph(vid, cf, timeframe){
    const model_key = vid+'_'+timeframe+'_'+cf
    const params={
      tid:  model_key,
      vid:  vid,
      cf:  cf,
      timeframe:timeframe,
    }
    const filter = [
      'time',
      'maxdisk',
      'disk',
      ...Object.keys(params)
    ]
    if(timeframe==='live') {
      const res = await axios.get('/datacenter/vservers/' + vid + '/status')
        .then(response=>{
          const timestamp = Math.floor(Date.now() / 1000)
          const res = Object.assign({}, response.data.status)
          res['time'] = timestamp
          const d = VserverGraph.find(model_key)  ? JSON.parse(JSON.stringify(VserverGraph.find(model_key)))
                                                  : JSON.parse(JSON.stringify(new VserverGraph))
          const data = Object.assign({},d,params)
          const data_keys = Object.keys(new VserverGraph).map(el=>{
            res[el] ? data[el].push(res[el]) : undefined
          })
          VserverGraph.insertOrUpdate({data:data})


        })
        .catch(
          error=>{
            return error
          }
        )
      return
    }
    else{
    const x = axios.get("/datacenter/vservers/"+vid+"/graph",{params:{
      timeframe:timeframe,
      cf:cf.toUpperCase()
        }})
      .then(res=>{
        let m = JSON.parse(JSON.stringify( new VserverGraph ))
        delete m.$id
        delete m.vid
        delete m.timeframe
        delete m.cf
        const keys = Object.keys(m).map(el=>el)
        const z = res.data.graph.data.map(el=>{
          if(el['mem'] || el['cpu'] || el['net'] || el['disk']){
            keys.map(key=>{
            m[key] && el[key]   ? m[key].push(el[key]) : ''
          })}
        })
        m.tid = model_key
        m.vid = vid
        m.cf=cf
        m.timeframe = timeframe
        VserverGraph.insertOrUpdate({data:m})
        })
      .catch(err=>{console.log(err)})
    }
  }
}
export default VserverGraph



// WEBPACK FOOTER //
// ./src/store/models/vserver/vserver_graph.js